"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import { cn } from "../../lib/utils";

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer grid size-3.5 shrink-0 place-items-center rounded-xs",
      // The unchecked box is now a filled well instead of an outlined one. It
      // rests on `bg-sunken-strong` rather than `bg-sunken`: at 14px there is
      // no interior to read, so the box only exists if its fill is the stronger
      // of the two wells — hover then steps to `bg-active`.
      "bg-sunken-strong text-text-inverse",
      "transition-[background-color,color] duration-100 ease-out-fast",
      "hover:bg-active",
      "focus-visible:outline-none focus-fill",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-accent",
      "data-[state=indeterminate]:bg-accent",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      {props.checked === "indeterminate" ? (
        <Minus className="size-2.5" strokeWidth={3} />
      ) : (
        <Check className="size-2.5" strokeWidth={3} />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
